import { LdetalleContrato } from './ldetalleContrato';
export class DatosOroavisosModel {
  descCanalOroavisos!: string;
  codigoCanal!: string;
  formaPago!: string;
  producto!: string;
  codigoServicio!: number;
  consultaCheque!: boolean;
  verificaLinea!: boolean;
  verificaCobroPendiente!: boolean;
  usuario!: string;
  programa!: string;
  codMotivoReverso!: number;
  codTransacionReverso!: number;
  codigoMotivoComision!: number;
  codigoTransaccionComision!: number;
  montoMov!: number;
  refere!: number;
  refere1!: number;
  codigoMotivoMov!: number;
  codigoTransaccionMov!: number;
  ldetalleContrato: LdetalleContrato[] = [];

  clear() {
    this.descCanalOroavisos = '';
    this.codigoCanal = '';
    this.formaPago = '';
    this.producto = '';
    this.codigoServicio = 0;
    this.consultaCheque = false;
    this.verificaLinea = false;
    this.verificaCobroPendiente = false;
    this.usuario = '';
    this.programa = '';
    this.codMotivoReverso = 0;
    this.codTransacionReverso = 0;
    this.codigoMotivoComision = 0;
    this.codigoTransaccionComision = 0;
    this.montoMov = 0;
    this.refere = 0;
    this.refere1 = 0;
    this.codigoMotivoMov = 0;
    this.codigoTransaccionMov = 0;
    this.ldetalleContrato = new Array<LdetalleContrato>();
  }
  
}
